import { reactive, toRefs, ref } from 'vue'
import apiCustomer from '../api/customer.api'
import apiAddress from '../api/address.api'

const state = reactive({
  customerList: [],
  filterOptions: {},
  loading: false,
  pagination: ref({
    page: 1,
    rowsPerPage: 20,
    rowsNumber: 0
  }),
})

const getSummary = async (params) => {
  state.paginationInfoLoading = true

  try {
    const { data: { total } } = await apiCustomer.getTotal(params)

    state.pagination.rowsNumber = total
  } catch {
  } finally {
    state.paginationInfoLoading = false
  }
}

export default function useCustomer() {

  const getCustomerList = async (params) => {
    state.loading = true
    getSummary(params)
    const { data } = await apiCustomer.getList(params)

    state.customerList = Object.freeze(data)
    state.filterOptions = params

    state.pagination.page = params?.page ? params.page : 1
    state.pagination.rowsPerPage = params["page-size"] ? params["page-size"] : 20

    state.loading = false
  }

  const clearCustomerList = () => {
    state.customerList = []
    state.filterOptions = {}
    state.pagination.rowsNumber = 0
    state.pagination.page = 1
  }

  return {
    ...toRefs(state),
    getCustomerList,
    clearCustomerList,
  }
}